const forms = [
    {
        name: "Details",
        options: [
            {
                name: "Name",
                type: "input",
                form: {
                    type: "text",
                    name: "name",
                    placeholder: "Site name",
                    class: "",
                    value: "",
                    required: true,
                },
            },
            {
                name: "Type",
                type: "select",
                form: {
                    name: "type",
                    allowClear: false,
                    placeholder: "Select type",
                    value: "Site",
                    options: [
                        { value: "Site", label: "Site" },
                        { value: "Project", label: "Project" },
                        { value: "Department", label: "Department" },
                    ],
                    required: false,
                },
            },
            {
                name: "Manager",
                type: "input",   // assuming you have a user search/select component
                form: {
                    type: "text",
                    name: "manager",
                    placeholder: "Manager name",
                    class: "",
                    value: "",
                    required: false,
                },
            },
        ],
    },
    {
        name: "Location",
        options: [
            {
                name: "Address",
                type: "input",
                form: {
                    type: "text",
                    name: "address",
                    placeholder: "Site address",
                    class: "",
                    value: "",
                    required: false,
                },
            },
            {
                name: "GPS Coordinates",
                type: "input",
                form: {
                    type: "text",
                    name: "gps_coordinates",
                    placeholder: "e.g. 23.5880, 58.3829",
                    class: "",
                    value: "",
                    required: false,
                },
            },
        ],
    },
    {
        name: "Contact",
        options: [
            {
                name: "Contact Number",
                type: "input",
                form: {
                    type: "text",
                    name: "contact_number",
                    placeholder: "Site contact number",
                    class: "",
                    value: "",
                    required: false,
                },
            },
            {
                name: "Notes",
                type: "input",
                form: {
                    type: "text",
                    name: "notes",
                    placeholder: "Any remarks",
                    class: "",
                    value: "",
                    required: false,
                },
            },
        ],
    },
    {
        name: "Status",
        options: [
            {
                name: "Status",
                type: "select",
                form: {
                    name: "status",
                    allowClear: false,
                    placeholder: "Status",
                    value: 1,
                    options: [
                        { value: 1, label: "Active" },
                        { value: 0, label: "In-active" },
                    ],
                    required: false,
                },
            },
        ],
    },
];

export default forms;